import { type Common } from './common.js';
import {
  type CreateValues,
  type FindAllOptions,
  type ProvisionalPatient,
} from './models/patient/provisional.js';

interface SendResponse {
  success: boolean;
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  // TODO: lint fix
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async findAll(options: FindAllOptions): Promise<ProvisionalPatient[]> {
    const url = this.common.constructPath('/provisional-patients');
    return await this.common.getJSON(url);
  }

  async createBulk(payload: {
    previsitLinkId: string;
    patients: CreateValues[];
  }): Promise<ProvisionalPatient[]> {
    const url = this.common.constructPath(`/provisional-patients`);
    return await this.common.postJSON(url, payload);
  }

  async sendText(id: string, payload: { checkRateLimiter?: boolean } = {}): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/text`);
    return await this.common.postJSON(url, payload);
  }

  async sendEmail(id: string, payload: { checkRateLimiter?: boolean } = {}): Promise<SendResponse> {
    const url = this.common.constructPath(`/provisional-patients/${id}/email`);
    return await this.common.postJSON(url, payload);
  }
}
